import request from './requestUtils'

export async function clearChannelMarkup(): Promise<void> {
  await request.post<void, unknown>('/api/channel-markup/clear', undefined, {}, '')
}
